import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('TextField/types');
export var TextFieldView;

(function (TextFieldView) {
  TextFieldView["default"] = "default";
  TextFieldView["innerLabel"] = "innerLabel";
})(TextFieldView || (TextFieldView = {}));